import Dialog from "@material-ui/core/Dialog";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import InputFiled from "../FormElement/InputFiled";

class DatePickerRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDateRangeOpen: false,
      dateRangeDisplayValue: false,
      OKDisabled: true,
      selectedRange: null
    };
  }

  onDataRangeSelect = range => {
    console.log(range);
    this.setState({
      selectedRange: range,
      OKDisabled: false
    });
  };

  toggleDataRangePicker = () => {
    const { isDateRangeOpen } = this.state;
    this.setState({
      isDateRangeOpen: !isDateRangeOpen
    });
  };
  onOKClick = () => {
    this.toggleDataRangePicker();
    const { onSelect } = this.props;
    const { selectedRange } = this.state;
    onSelect(selectedRange);
    const { start, end } = selectedRange;
    const start_date = moment(start).format("MM-DD-YYYY");
    const end_date = moment(end).format("MM-DD-YYYY");
    this.setState({
      dateRangeDisplayValue: `${start_date} to ${end_date}`
    });
  };

  render() {
    const {
      OKDisabled,
      dateRangeDisplayValue,
      isDateRangeOpen,
      selectedRange
    } = this.state;
    return (
      <div>
        <InputFiled
          className="load-date-range"
          value={
            dateRangeDisplayValue
              ? dateRangeDisplayValue
              : "Click to select Date Range"
          }
          label="Load Date Range"
          type="text"
          name="dateRange"
          handleClick={this.toggleDataRangePicker}
          handleChange={() => {}}
        />
        {isDateRangeOpen && (
          <Dialog
            open={isDateRangeOpen}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <div>
              {/* <DateRange onChange={this.onDataRangeSelect} /> */}
              <DateRangePicker
                onSelect={this.onDataRangeSelect}
                value={selectedRange}
                // numberOfCalendars= {2}
              />
              <div className="control-bar">
                <div
                  className="cancel-button"
                  onClick={this.toggleDataRangePicker}
                >
                  Cancel
                </div>
                <div
                  className={OKDisabled ? "ok-button disabled" : "ok-button"}
                  onClick={() => this.onOKClick()}
                >
                  OK
                </div>
              </div>
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}

DatePickerRange.propTypes = {
  onSelect: PropTypes.func.isRequired
};

export default DatePickerRange;



// WEBPACK FOOTER //
// ./src/components/FormElement/DatePickerRange.js